import React from 'react';

import PropTypes from 'prop-types';
import { flexRender } from '@tanstack/react-table';

import { TableCell, TableRow } from '@/components/ui/table';

const Row = ({ row }) => (
  <TableRow data-state={row.getIsSelected() && 'selected'}>
    {row.getVisibleCells().map((cell) => (
      <TableCell className={cell.column.columnDef.meta?.className} key={cell.id}>
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </TableCell>
    ))}
  </TableRow>
);

Row.propTypes = {
  row: PropTypes.shape({
    getIsSelected: PropTypes.func.isRequired,
    getVisibleCells: PropTypes.func.isRequired,
  }).isRequired,
};

export default Row;
